import { ActionIcon, Menu } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { useBulkReview } from '#components/ChangeTracking/hooks'
import { FaIcon } from '#components/FaIcon'
import { FancyMenuItem } from '#components/FancyMenuItem'
import { ILoadedScript } from '#state'

export const BulkReviewMenu = observer(function BulkReviewMenu({
  disabled,
  script,
}: {
  disabled: boolean
  script: ILoadedScript
}) {
  const count = ` (${script.changeTrackingData.proposedChanges.length})`
  const bulkReview = useBulkReview({ script })

  return (
    <Menu shadow="md">
      <Menu.Target>
        <ActionIcon variant="neutral">
          <FaIcon icon="fa-ellipsis" />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <FancyMenuItem
          disabled={disabled}
          onClick={() => bulkReview.mutate('approve')}
          iconClass="fas fa-check"
          title={'Accept all changes' + count}
        />
        <FancyMenuItem
          disabled={disabled}
          onClick={() => bulkReview.mutate('reject')}
          iconClass="fas fa-ban"
          title={'Decline all changes' + count}
        />
      </Menu.Dropdown>
    </Menu>
  )
})
